import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { CaretLeft, CaretRight, X } from '@phosphor-icons/react';
import { useHorizontalSwipe } from '../../../../../shared/hooks/useHorizontalSwipe';

type PublicShareLightboxProps = {
  images: string[];
  initialIndex: number;
  onClose: () => void;
  t: any;
};

export default function PublicShareLightbox({ images, initialIndex, onClose, t }: PublicShareLightboxProps) {
  const [index, setIndex] = useState(initialIndex);
  const previous = () => setIndex((value) => (value - 1 + images.length) % images.length);
  const next = () => setIndex((value) => (value + 1) % images.length);
  const swipe = useHorizontalSwipe({ enabled: images.length > 1, onSwipeLeft: next, onSwipeRight: previous });

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
      if (event.key === 'ArrowLeft') previous();
      if (event.key === 'ArrowRight') next();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  });

  if (!images[index]) return null;

  return createPortal(
    <div className="lightbox" role="dialog" aria-modal="true" aria-label={t.gallery} onMouseDown={(event: any) => event.target === event.currentTarget && onClose()} {...swipe}>
      <button className="lightbox-close" onClick={onClose} aria-label={t.closeGallery}><X /></button>
      {images.length > 1 && <><button className="lightbox-arrow previous" onClick={previous} aria-label={t.previousImage}><CaretLeft /></button><button className="lightbox-arrow next" onClick={next} aria-label={t.nextImage}><CaretRight /></button></>}
      <img src={images[index]} alt="" draggable="false" />
      <div className="lightbox-footer"><span>{index + 1} / {images.length}</span></div>
    </div>,
    document.body,
  );
}
